//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
  name: "FilingGuidelinesGuidelines",
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapGetters(["config", "results"]),
  },
  methods: {
    populateCell(val) {
      // Return if the value is null so it doesn't try to format it as "$0.00".
      if (val === null || val === undefined || typeof val === 'string') {
        return val;
      } else {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',

          // These options are needed to round to whole numbers if that's what you want.
          //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
          //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });
        return formatter.format(val)
      }
    }

  }
};
